import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react"
import Lightbox from "yet-another-react-lightbox"
import Zoom from "yet-another-react-lightbox/plugins/zoom"
import { toast } from "react-toastify"
import clsx from "clsx"

import { InfiniteScrollLoader, Spinner, VirtualGrid } from "components"
import FuwgCard from "./FuwgCard"
import { getMedia } from "services"
import FuwFooter from "../FuwFooter"
import FuwgFooter from "./FuwgFooter"
import classes from "./index.module.scss"
import { useTranslation } from "react-i18next"

const limit = 30

const breakPoints = [{
  point: 1600,
  rowHeight: 100,
  numberOfColumns: 5
}]

const FuwGallery = props => {
  const {
    setTab,
    setFiles,
    accountId,
    imageCategory,
    gallery,
    setGallery,
    skip,
    setSkip,
    hasMore,
    setHasMore,
    numberOfFiles,
    originalFiles,
    maxNumberOfUploads
  } = props

  const [t] = useTranslation()

  const [photoIndex, setPhotoIndex] = useState(0)
  const [selectedImages, setSelectedImages] = useState({})
  const [openGalleryPopup, setOpenGalleryPopup] = useState(false)

  const handleOpenLightBox =
    useCallback((imageIndex) => {
      setPhotoIndex(imageIndex)

      setOpenGalleryPopup(true)
    }, [])

  const handleSelect =
    useCallback((image) => {
      setSelectedImages(prev => {
        const previoiusSelectedImages = { ...prev }

        const isSelected =
          previoiusSelectedImages[image.url]

        if (isSelected) {

          delete previoiusSelectedImages[image.url]

          return previoiusSelectedImages
        }

        const numberOfSelectedImages =
          Object.keys(previoiusSelectedImages).length

        if (maxNumberOfUploads === numberOfSelectedImages) {
          toast.error(t("حداکثر_maxNumberOfUploads_فایل_می_توان_انتخاب_کرد", { maxNumberOfUploads }))

          return previoiusSelectedImages
        }

        previoiusSelectedImages[image.url] = image

        return previoiusSelectedImages
      })
    }, [])

  const loadMore =
    useCallback(async () => {
      const response =
        await getMedia({
          skip,
          limit,
          accountId,
          imageCategory
        })

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      const gallery =
        response.map((image, i) =>
          ({ ...image, imageIndex: skip + i })
        )

      setGallery(prev => [...prev, ...gallery])
    }, [skip, accountId, imageCategory])

  const getGallery = async () => {
    if (gallery !== null) return

    try {
      const response =
        await getMedia({
          skip: 0,
          limit,
          accountId,
          imageCategory
        })

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      const gallery =
        response.map((image, i) =>
          ({ ...image, imageIndex: i })
        )

      setGallery(gallery)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getGallery()
  }, [accountId, imageCategory])

  const slides =
    useMemo(() => {
      if (!gallery) return []

      return gallery.map(image => ({ src: image.url }))
    }, [gallery])

  const showFooter = numberOfFiles > 0

  return (
    <Fragment>
      <div
        className={clsx(
          classes["container"],
          showFooter && classes["shrink"]
        )}
      >
        <div className={classes["wrapper"]}>
          {gallery !== null
            ?
            <VirtualGrid
              keyField="_id"
              data={gallery}
              offset={2}
              hasMore={hasMore}
              dataLength={skip}
              next={loadMore}
              loader={<InfiniteScrollLoader />}
              breakPoints={breakPoints}
              className={classes["grid"]}
              listEmptyComponent={
                <div className={classes["no"]}>
                  {t("هیچ_فایلی_یافت_نشد")}
                </div>
              }
              renderItem={image =>
                <FuwgCard
                  image={image}
                  onSelect={handleSelect}
                  onOpenLightBox={handleOpenLightBox}
                  isSelected={!!selectedImages[image.url]}
                />
              }
            />
            :
            <div className={classes["loader"]}>
              <Spinner
                className={classes["spinner"]}
              />
            </div>
          }
        </div>
      </div>
      {numberOfFiles > 0
        ?
        <FuwFooter
          setTab={setTab}
          numberOfFiles={numberOfFiles}
        />
        :
        <FuwgFooter
          setTab={setTab}
          setFiles={setFiles}
          selectedImages={selectedImages}
          originalFiles={originalFiles}
          maxNumberOfUploads={maxNumberOfUploads}
        />
      }
      <Lightbox
        open={openGalleryPopup}
        plugins={[Zoom]}
        index={photoIndex}
        styles={{ toolbar: { direction: "ltr" } }}
        close={() => setOpenGalleryPopup(false)}
        slides={slides}
        zoom={{
          scrollToZoom: true,
          maxZoomPixelRatio: 5
        }}
      />
    </Fragment>
  )
}

export default FuwGallery